import { render, staticRenderFns } from "./MultiFileJXS.vue?vue&type=template&id=0543f750&scoped=true&"
import script from "./MultiFileJXS.vue?vue&type=script&lang=js&"
export * from "./MultiFileJXS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0543f750",
  null
  
)

export default component.exports